// extracted by mini-css-extract-plugin
var _1 = "pfx-Banner-module__banner-actions--zvV7G";
var _2 = "pfx-Banner-module__banner-content--wkm47";
var _3 = "#000";
var _4 = "1260px";
var _5 = "1020px";
var _6 = "668px";
var _7 = "1550px";
var _8 = "pfx-Banner-module__container--Hp39K";
var _9 = "1140px";
var _a = "940px";
var _b = "100%";
var _c = "15px";
var _d = "620px";
var _e = "#f53535";
var _f = "rgba(0,0,0,.2)";
var _10 = "rgba(255,255,255,.38)";
var _11 = ".38";
var _12 = "pfx-Banner-module__error--SA0PE";
var _13 = "rgba(255,255,255,.2)";
var _14 = "#0025ff";
var _15 = "pfx-Banner-module__glitch-anim--Mm_AJ";
var _16 = "pfx-Banner-module__glitch-anim-2--sOfJK";
var _17 = "#f60";
var _18 = "#41ead4";
var _19 = "#2cdd78";
var _1a = "#66ab23";
var _1b = "#f5f5f5";
var _1c = "#c3c3c3";
var _1d = "#ececec";
var _1e = "#252525";
var _1f = "#272727";
var _20 = "#c6c6c5";
var _21 = "#333";
var _22 = "#3c3c3c";
var _23 = "#9c9b9b";
var _24 = "#8c8c8c";
var _25 = "#6f6f6e";
var _26 = "#3c3c3b";
var _27 = "#373737";
var _28 = "#6a6a69";
var _29 = "#6f6f6f";
var _2a = "#9f9e9e";
var _2b = "#282828";
var _2c = "#828181";
var _2d = "#1d1d1d";
var _2e = "#979797";
var _2f = "#9c9b9b";
var _30 = "#a7a7a6";
var _31 = "#c6c6c5";
var _32 = "#d8d8d7";
var _33 = "#dddddc";
var _34 = "72px";
var _35 = "40px";
var _36 = "36px";
var _37 = "25px";
var _38 = "18px";
var _39 = "13px";
var _3a = "pfx-Banner-module__icon--qpdmF";
var _3b = "#0025ff";
var _3c = "rgba(255,255,255,.12)";
var _3d = "#6535f5";
var _3e = "2px";
var _3f = "56px";
var _40 = "56px";
var _41 = "#41ead4";
var _42 = "#f60";
var _43 = "#f83600";
var _44 = "#881f00";
var _45 = "18px";
var _46 = "15px";
var _47 = "pfx-Banner-module__promotion--Kw_C7";
var _48 = "red";
var _49 = "13px";
var _4a = "rgba(255,255,255,.07)";
var _4b = "pfx-Banner-module__text--QIN9g";
var _4c = "#35465c";
var _4d = "#55acee";
var _4e = "pfx-Banner-module__warning--Ux5P2";
var _4f = "#fff";
var _50 = "#ffce36";
var _51 = "#ffcd00";
var _52 = "red";
export { _1 as "bannerActions", _2 as "bannerContent", _3 as "black", _4 as "breakLarge", _5 as "breakMedium", _6 as "breakSmall", _7 as "breakVLarge", _8 as "container", _9 as "containerLarge", _a as "containerMedium", _b as "containerMobile", _c as "containerPaddingMobile", _d as "containerSmall", _e as "danger", _f as "darkElement", _10 as "disabled", _11 as "disabledOpacity", _12 as "error", _13 as "extraLightElement", _14 as "facebook", _15 as "glitchAnim", _16 as "glitchAnim2", _17 as "google", _18 as "green", _19 as "green2", _1a as "greenColor", _1b as "grey1", _1c as "grey10", _1d as "grey2", _1e as "grey25", _1f as "grey27", _20 as "grey3", _21 as "grey33", _22 as "grey3C", _23 as "grey4", _24 as "grey41", _25 as "grey5", _26 as "grey6", _27 as "grey61", _28 as "grey6A", _29 as "grey6F", _2a as "grey7", _2b as "grey8", _2c as "grey82", _2d as "grey9", _2e as "grey97", _2f as "grey9C", _30 as "greyA7", _31 as "greyC6", _32 as "greyD8", _33 as "greyDd", _34 as "header1", _35 as "header2", _36 as "header3", _37 as "header4", _38 as "header5", _39 as "header6", _3a as "icon", _3b as "klein", _3c as "lightElement", _3d as "lilac", _3e as "menuBorder", _3f as "menuHeight", _40 as "menuMobileHeight", _41 as "ocean", _42 as "orange", _43 as "orange2", _44 as "orangeDark", _45 as "paragraph", _46 as "paragraphSmall", _47 as "promotion", _48 as "red", _49 as "subHeaderSmall", _4a as "subtleLightElement", _4b as "text", _4c as "tumblr", _4d as "twitter", _4e as "warning", _4f as "white", _50 as "yellow", _51 as "yellowDeep", _52 as "youtube" }
